import { get } from 'lodash';
import queryString from 'query-string';
import axios, { baseUrl } from './axios';
import { getAuth } from './localStorage';

export default {
  view_GET_OTP: async options => {
    const result = await axios.post(
      `${baseUrl}/scheduler/pob/customer/verify?emailMobile=${get(
        options.data,
        'emailMobile',
        '',
      )}`,
      {
        ...options.data,
      },
    );
    return result.data;
  },
  viewAppointments: async options => {
    const result = await axios.post(
      `${baseUrl}/scheduler/pob/appointments/verify?code=${get(
        options.data,
        'code',
        '',
      )}`,
      {
        ...options.data,
      },
    );
    return result.data;
  },
  viewAppointmentsLoginUser: async options => {
    const params = queryString.stringify(options.data);
    const auth = getAuth();
    const result = await axios.get(
      `${baseUrl}/scheduler/pob/next-appointments${params ? `?${params}` : ''}`,
      {
        headers: {
          Authorization: 'Bearer ' + auth.token,
        },
      },
    );
    return result.data;
  },
  verifyModifyBooking: async options => {
    const params = queryString.stringify(options.data);
    const result = await axios.post(
      `${baseUrl}/scheduler/pob/modify_appointment/verify${
        params ? `?${params}` : ''
      }`,
    );
    return result.data;
  },
  cancelBooking: async options => {
    const params = queryString.stringify(options.data);
    const result = await axios.put(
      `${baseUrl}/scheduler/pob/cancel_appointment${
        params ? `?${params}` : ''
      }`,
    );
    return result.data;
  },
  rescheduleBooking: async options => {
    const { code, booking_id, booking_data } = options.data || {};
    const params = queryString.stringify({ code, bookingId: booking_id });
    const result = await axios.put(
      `${baseUrl}/scheduler/pob/reschedule_appointment${
        params ? `?${params}` : ''
      }`,
      {
        booking_id,
        booking_data,
      },
    );
    return result.data;
  },
  viewAppointmentViaLinks: async options => {
    const params = queryString.stringify(options.data);
    const result = await axios.get(
      `${baseUrl}/scheduler/pob/appointment/confirm_link${
        params ? `?${params}` : ''
      }`,
    );
    return result.data;
  },
};
